export const subscriptionPlan = {
    name: "",
    price: "",
    profilePerPlan: "",
    weeklyProfileCount: "",
    planAsstFeature: "",
    isActive: true
}